var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPipe7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 350,
    height: 165,
    viewBox: "0 0 350 165",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 44.8878C45 50.1345 49.2533 54.3878 54.5 54.3878L295.5 54.3878C325.599 54.3878 350 78.7882 350 108.888L350 165L305 165L305 108.888C305 103.641 300.747 99.3878 295.5 99.3878L54.5 99.3878C24.4004 99.3878 -3.69481e-06 74.9873 5.25028e-06 44.8877L1.67491e-05 0L45 1.72258e-05L45 44.8878Z",
    fill: "#BED4ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182 76.4814L165.203 57.0118L165.203 95.9509L182 76.4814Z",
    fill: "url(#paint0_linear_12_73)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.604 76.4999L151.806 57.0304L151.806 95.9695L168.604 76.4999Z",
    fill: "url(#paint1_linear_12_73)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.207 76.5186L138.41 57.0491L138.41 95.9882L155.207 76.5186Z",
    fill: "url(#paint2_linear_12_73)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M328.018 148.189L347.055 131.392L308.981 131.392L328.018 148.189Z",
    fill: "url(#paint3_linear_12_73)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M328 134.793L347.037 117.996L308.963 117.996L328 134.793Z",
    fill: "url(#paint4_linear_12_73)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M327.982 121.397L347.019 104.6L308.945 104.6L327.982 121.397Z",
    fill: "url(#paint5_linear_12_73)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_73",
    x1: 182,
    y1: 76.4814,
    x2: 159.604,
    y2: 76.4814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_73",
    x1: 168.604,
    y1: 76.4999,
    x2: 146.207,
    y2: 76.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12_73",
    x1: 155.207,
    y1: 76.5186,
    x2: 132.811,
    y2: 76.5186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12_73",
    x1: 328.018,
    y1: 148.189,
    x2: 328.018,
    y2: 125.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12_73",
    x1: 328,
    y1: 134.793,
    x2: 328,
    y2: 112.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12_73",
    x1: 327.982,
    y1: 121.397,
    x2: 327.982,
    y2: 99.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipe7);
export default __webpack_public_path__ + "static/media/pipe-7.39dbf67363b578c5e39280fe2555fcd9.svg";
export { ForwardRef as ReactComponent };